import React from 'react';
import cn from '@/utils/cn';

interface TabPanelProps<TTabId extends string> {
  id: TTabId;
  activeTab: TTabId;
  className?: string;
  children: React.ReactNode;
}

/**
 * Keeps every panel mounted and toggles visibility via `hidden` — switching tabs
 * doesn't remount/refetch the inactive panels.
 */
const TabPanel = <TTabId extends string>({
  id,
  activeTab,
  className,
  children
}: TabPanelProps<TTabId>) => (
  <div className={cn('px-4 py-4', activeTab !== id ? 'hidden' : '', className)}>{children}</div>
);

export default TabPanel;
